import { useMemo, useState, type ReactNode } from 'react';
import type { ScopeTransitionContextValue, ScopeTransition } from '../types';
import { ScopeTransitionContext } from '../contexts';

interface ScopeTransitionProviderProps {
  children: ReactNode;
}

export const ScopeTransitionProvider = ({
  children,
}: ScopeTransitionProviderProps) => {
  const [pendingTransition, setPendingTransition] =
    useState<ScopeTransition | null>(null);

  const requestTransition = (transition: ScopeTransition) => {
    setPendingTransition(transition);
  };

  const clearTransition = () => {
    setPendingTransition(null);
  };

  const contextValue: ScopeTransitionContextValue = useMemo(
    () => ({
      pendingTransition,
      requestTransition,
      clearTransition,
    }),
    [pendingTransition]
  );

  return (
    <ScopeTransitionContext.Provider value={contextValue}>
      {children}
    </ScopeTransitionContext.Provider>
  );
};
